import * as z from "zod";
import type { LSLocality } from "./locality";
import type { LSSuburb } from "./suburb";

export const LSLocationSchema = z.object({
	locationKey: z.string().optional().default(""),
	locationName: z.string().min(1, "Name is required"),
	localityID: z.string().optional(),
	address1: z.string().min(1, "Address is required"),
	address2: z.string().optional(),
	suburb: z.string().min(1, "Suburb is required"),
	state: z.string().min(1, "State is required"),
	postCode: z.coerce.string().min(1, "Postcode is required"),
	region: z.string().optional(),
	contact: z.string().optional(),
	phoneNum: z.string().optional(),
	instructions: z.string().optional().default(""),
	airport: z.boolean().default(false),
	blockEdit: z.boolean().default(false),
	latitude: z.string().optional().default(""),
	longitude: z.string().optional().default(""),
});
export type LSLocation = z.infer<typeof LSLocationSchema>;

export const LSLocationPartialSchema = LSLocationSchema.partial();
export type LSLocationPartial = z.infer<typeof LSLocationPartialSchema>;

export const LSFavouriteLocationSchema = LSLocationSchema.omit({
	address1: true,
	postCode: true,
}).extend({
	address1: z.string().optional(),
	postCode: z.string().optional(),
});
export type LSFavouriteLocation = z.infer<typeof LSFavouriteLocationSchema>;

export interface ILocationRepository {
	getLocations(): Promise<LSLocation[]>;
	getLocationsBackend(localityId: string, suburbPartial?: string): Promise<LSFavouriteLocation[]>;
	saveLocation(location: LSLocation): Promise<LSLocation>;
	getLocalities(): Promise<LSLocality[]>;
	getSuburbs(localityID: string, suburbPartial: string): Promise<LSSuburb[]>;
}
